<div id="preloader">
  <div class="spinner">
    <div class="double-bounce1" />
    <div class="double-bounce2" />
  </div>
</div>
